import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fadeUp } from "./motion";

const Footer = () => (
  <footer id="contacto" className="bg-[#0A0A0A] text-white pt-24 lg:pt-36 pb-10 px-6 lg:px-12" data-testid="contact-section">
    <div className="max-w-[1600px] mx-auto">
      <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }}>
        <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#EAB308]">Contacto</span>
        <h2 className="font-display font-bold uppercase tracking-tighter leading-[0.9] text-[11vw] lg:text-[8vw] mt-6">
          ¿Tu marca es<br /><span className="font-serif-accent normal-case tracking-normal text-[#EAB308]">la siguiente</span><span className="text-[#DB2777]">?</span>
        </h2>
        <a
          href="mailto:support@rockyltd.com"
          data-testid="contact-email-link"
          className="group inline-flex items-center gap-3 mt-10 font-display font-semibold text-2xl lg:text-4xl tracking-tight link-line"
        >
          support@rockyltd.com
          <ArrowUpRight className="w-7 h-7 lg:w-9 lg:h-9 text-[#EAB308] group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />
        </a>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-24 pt-10 border-t border-white/10">
        <div data-testid="footer-hub-panama">
          <span className="text-xs uppercase tracking-[0.25em] font-bold text-white/40 block mb-3">Hub regional</span>
          <p className="text-lg font-semibold">Panamá</p>
          <p className="text-sm text-white/50 mt-1">Logística estratégica, bodega central e import/export.</p>
        </div>
        <div data-testid="footer-hub-colombia">
          <span className="text-xs uppercase tracking-[0.25em] font-bold text-white/40 block mb-3">Oficina clave</span>
          <p className="text-lg font-semibold">Colombia</p>
          <p className="text-sm text-white/50 mt-1">Ventas, desarrollo de negocios y acceso directo al mercado.</p>
        </div>
        <div className="flex flex-col gap-3" data-testid="footer-links">
          <span className="text-xs uppercase tracking-[0.25em] font-bold text-white/40">Síguenos</span>
          <a href="https://www.linkedin.com/company/rocky-ltd/" target="_blank" rel="noopener noreferrer" className="link-line w-fit text-sm font-semibold" data-testid="footer-linkedin-link">LinkedIn</a>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mt-16 pt-8 border-t border-white/10 text-xs uppercase tracking-[0.2em] text-white/40">
        <span data-testid="footer-copyright">© 2026 Rocky Limited — LATAM &amp; Caribe</span>
        <span>Escalando marcas emergentes desde 2018</span>
      </div>
    </div>
  </footer>
);

export default Footer;
